import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { MergeFeatureComponent } from './merge-feature/merge-feature.component';

const log = new LoggingService();

export const MergeRoute: Ng2StateDeclaration = {
    name: 'merge',
    url: '/merge',
    data: { requiresAuth: true },

    component: MergeFeatureComponent
};